import { inject } from '@angular/core';
import { RoleAccessService } from '@shared/auth/services/role-access.service';
import { HeaderConfig } from '@shared/configs/header.config';
import { TabLink } from '@shared/interfaces/menu/tab-link.interface';
import { StorageService } from '@core/services/storage.service';
import { BasePanelChangeEvent, BasePanelChangeEventType, BasePanelService } from '@shared/modules/base-panel/services/base-panel.service';

export class BaseNavigationComponent {
  tabLinks: TabLink[] = [];
  protected readonly store = inject(StorageService);
  protected readonly basePanelService = inject(BasePanelService);
  protected readonly roleAccessService = inject(RoleAccessService);

  constructor() {
    this.listenHeaderChanges();
    this.configureNavigation();
  }

  listenHeaderChanges() {
    this.basePanelService.panelChangeEmitter.subscribe((e: BasePanelChangeEvent) => {
      switch (e.type) {
        case BasePanelChangeEventType.RECONFIGURE_NAVIGATION:
          this.tabLinks = [];
          this.configureNavigation();
          break;
      }
    });
  }

  configureNavigation() {
    this.tabLinks = (Object.values(HeaderConfig) as TabLink[]).filter((tabLink) =>
      this.roleAccessService.hasAnyRole(tabLink.roles)
    );
  }
}
